export default "__VITE_ASSET__CVReZhJA__"